<!DOCTYPE html>
<html lang="en">
<meta http-equiv="content-type" content="text/html;charset=utf-8" />
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Food Safety on Wheels</title>

	<script src="/assets/js/jquery.min.js"></script>

	<link rel="stylesheet" href="/assets/css/bootstrap.css" />
    <link rel="stylesheet" href="/assets/css/style.css" />
    <link rel="stylesheet" href="/assets/css/responsive.css" />
   <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" integrity="sha512-SfTiTlX6kk+qitfevl/7LibUOeJWlt9rbyDn92a1DqWOw9vWG2MFoays0sgObmWazO5BQPiFucnnEAjpAB+/Sw==" crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<body>



	<section class="top-menu">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					<nav class="navbar navbar-expand-md bg-dark navbar-dark">
					  <a class="navbar-brand" href="#"><img src="/assets/img/logo.png" style="width: 210px;"></a>
					  <img src="/assets/img/fsw_header1.png" style="width:380px; margin-left: 40px;">
					  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
						<span class="navbar-toggler-icon"></span>
					  </button>
					  <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar" >
						<ul class="navbar-nav" style="font-size:13px;">
						  <li class="nav-item">
							<a class="nav-link" [routerLink]="['/home']">Home</a>
						  </li>
						  <li class="nav-item">
							<a class="nav-link" [routerLink]="['/contact']">Contact</a>
						  </li>

						  <div class="dropdown">
							<button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
								<b>User Manual</b>
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
							  <a class="dropdown-item" href="./assets/document/Nodal Officers -User_Manual FSW.pdf" target="_blank">
								1. Nodal Officers
							</a>
							<a class="dropdown-item" href="./assets/document/FSW (Vehicle) User Manual.pdf" target="_blank">
								2. FSW (Vehicles)
							</a>
							<a class="dropdown-item" href="./assets/document/FSW User Manual ( Testing Module ).pdf" target="_blank">
								3. Test Reports (Testing)
							</a>
							</div>
						  </div>

						&nbsp;&nbsp;

						<li class="nav-item">
             				 <button type="button" class="btn btn-primary" routerLink="/login">Login</button>
						</li>

						<li class="nav-item">
							<a class="nav-link" [routerLink]="['/home/hi']">Hindi</a>
						</li>

						</ul>
					  </div>
					</nav>
				</div>
			</div>
		</div>
	</section>

	<section class="slider-sec">
		<div id="demo" class="carousel slide" data-ride="carousel">
			  <div class="carousel-inner">
				<div class="carousel-item active">
					<img src="/assets/img/slide-image/fsw4.jpg" class="img-fluid">
				</div>
				<div class="carousel-item">
					<img src="/assets/img/slide-image/fsw3.jpg" class="img-fluid">
				</div>
				<div class="carousel-item">
					<img src="/assets/img/slide-image/fsw1.jpg" class="img-fluid">
				  <div class="carousel-caption">
				  </div>
				</div>
			  </div>
			  <div _ngcontent-iyl-c80="" class="counterbox fontSize1">
				<div class="row"><div class="col-md-6">
				<div class="divcount">
					<span class="counter">{{totalVehicle}}</span>
				<div class="title">
					Food Safety on Wheels Registered
				</div>
			</div>

			</div>
			<div class="col-md-6">
				<div class="divcount" style="border-right: 1px solid #e4e4e400!important;">
					<span class="counter">{{totalTrainings}}</span>
					<div class="title">
						Trainings Conducted
					</div>
				</div>
			</div>
		</div>

			<div class="row"><div class="col-md-6">
				<div class="divcount" >
					<span class="counter">{{totalTesting}}</span>
				<div class="title">
					Samples Tested
				</div>
			</div>

			</div><div class="col-md-6">
				<div class="divcount" style="border-right: 1px solid #e4e4e400!important;">
					<span class="counter">{{totalawps}}</span>
					<div class="title">
						Awareness Programs Conducted
					</div>
				</div>
			</div></div>

		</div>
			  <div class="whats-new fontSize" style="font-size: 100%;">


				<h2 class="whats-heading">Consumer Corner</h2>



			  <div class="pull-right">
				 <div class="marts-marq">
				   <span><a class="btn btn-default" onClick="document.getElementById('mymarquee').stop();"><i class="fa fa-pause" aria-hidden="true" style="font-size: 12px;"></i></a></span>
					 <span><a class="btn btn-default" onClick="document.getElementById('mymarquee').start();"><i class="fa fa-play" aria-hidden="true" style="font-size: 12px;"></i></a></span>

				 </div>
			 </div>


		 <div class="clearfix"></div>
		 <div class="whats-new-marq">
		 <marquee behavior="scroll" direction="UP" id="mymarquee" scrolldelay="140">
		 <div class="view view-what-new view-id-what_new view-display-id-block view-what-new view-dom-id-ade44a657ac9df35c09fc58b7726b2b2">
					 <div class="view-header">

				<ul class="test arrows" style="margin-left: -29px;list-style: none;">
					<li>
						<a href="./assets/document/Statewise List of Nodal Officer - FSW (Mobile Lab).pdf" target="_blank">
						State-Wise list of Nodal officers</a>
					</li>

				</ul>
					</div>
		 </div>
		 </marquee>
		 </div>



		 </div>
			  <a class="carousel-control-prev" href="#demo" data-slide="prev">
				<span class="carousel-control-prev-icon"></span>
			  </a>
			  <a class="carousel-control-next" href="#demo" data-slide="next">
				<span class="carousel-control-next-icon"></span>
			  </a>
		</div>
	</section>

	<section class="about-sec">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					 <div class="section-title text-left">
						<h2 class="section-title__title"><span> Food Safety </span> On Wheels</h2>
						<p>Testing of food to instil confidence amongst consumers that food is safe to eat is important part of the food safety ecosystem. However, number and spread of food testing labs in the country is grossly inadequate. While, Food Safety and Standards Authority of India (FSSAI) is working towards having more food testing labs both in the public as well as private sector, it has also initiated a scheme to provide mobile units for food testing to reach out to consumers through as many touch points as possible.  </p>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="about-img-left">
								<img src="/assets/img/about/about1.jpg" class="img-fluid">
							</div>
						</div>
						<div class="col-md-6">
							<div class="about-text-right">
								<p class="welcome-one__right-text-2">These mobile units are called “Food Safety on Wheels”. Apart from conducting simple tests for common adulterants in milk, water, edible oil and other items of food of daily consumption, these mobile units would also be used for awareness building around food safety, hygiene and promoting healthy eating habits in citizens at large and for conducting training and certification programme for food handlers and supervisors in food businesses, particularly petty food businesses. In addition, these mobile units would help the field functionaries in the States to enhance their outreach and conduct surveillance activities even in far-flung areas. </p>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6 order-sm-1 order-2">
							<div class="about-img-left">
								<div class="about-text-right">
								<p class="welcome-one__right-text-2">It is hoped that with passage of time, services provided through these mobile units, ‘Food Safety on Wheels’ would become popular amongst all stakeholders, namely, the citizens, the consumers, the food businesses and the field functionaries of the Food Safety Departments in the States. This would help to bring about a paradigm shift in food safety ecosystem in the country.  </p>
							</div>
							</div>
						</div>
						<div class="col-md-6 order-1">
							<div class="about-img-left">
								<img src="/assets/img/about/fsw4.jpg" class="img-fluid">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 order-sm-1 order-2">
							<hr class="hr-line">
							<h2 style="text-align: center;" class="section-title__title">
							<span> Map </span> Display</h2>
							<hr class="hr-line">

                            <app-list-vehicle-statewise-home></app-list-vehicle-statewise-home>

						</div>
</div>
				</div>
			</div>
		</div>
	</section>

	<section class="footer-sec">
		<div class="container">
			<div class="row">
				<div class="col-xl-3 col-lg-6 col-md-6">
					<div class="footer-widget__about-logo">
						<img src="/assets/img/footer-logo.png"   style="width: 550px;" class="img-fluid">
					</div>
				</div>
				<div class="col-xl-2 col-lg-6 col-md-6">
					<div class="footer-widget__column footer-widget__explore clearfix">
						<h3 class="footer-widget__title">Explore</h3>
						<ul class="footer-widget__explore-list list-unstyled">
							<li><a href="/home">Home</a></li>
							<li><a [routerLink]="['/contact']">Contact</a></li>
						</ul>
					</div>
				</div>
				<div class="col-xl-3 col-lg-6 col-md-6">
					<div class="footer-widget__column footer-widget__contact">
						<h3 class="footer-widget__title">Contact</h3>
						<div class="footer-widget__contact-info">
							<p>
								<a href="#">03rd & 04th Floor, FDA Bhawan, Kotla Road near Bal Bhawan<br/> New Delhi - 110002 India.</a>
								<!-- <a href="#" class="footer-widget__contact-mail">labs@fssai.gov.in</a> -->
								<a href="#" class="footer-widget__contact-mail">fsw.mftl@fssai.gov.in</a>
							</p>
						</div>
					</div>
				</div>
				<div class="col-xl-4 col-lg-6 col-md-6 map-colm">
					<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.9079657926686!2d77.2353960860842!3d28.63252032692701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd29372d3d71%3A0x8832bf9b5824d477!2sFDA%20Bhawan%2C%20Kotla%20Marg%2C%20Mandi%20House%2C%20New%20Delhi%2C%20Delhi%20110002!5e0!3m2!1sen!2sin!4v1644560909906!5m2!1sen!2sin" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
				</div>

			</div>
		</div>
		<div class="site-footer-bottom">
			<div class="container">
				<div class="row">
					<div class="col-xl-12">
						<div class="site-footer-bottom__inner">
							<p class="site-footer-bottom__copy-right">&copy; Copyright {{ currentYear }}.
								<a href="#">Food Safety On Wheels</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</body>
</html>
